import React from 'react';

import { Footer, Header, PageLayout } from '../../components';
import PageContent from '../../features/SimDetail';

const SimDetailPage = () => {
  return (
    <>
      <Header />
      <PageLayout>
        <PageContent />
      </PageLayout>
      <Footer />
    </>
  );
};

export default SimDetailPage;
